import React, { Component } from 'react';
import CaptureSetup from '../../components/CaptureSetup/CaptureSetup';
import Questionnaire from '@components/Questionnaire';
import SessionStateManager from '@components/SessionStateManager';
import DataCaptureService from '@services/DataCaptureService';
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import styles from './datacapture.module.css';
import { CustomDialog, useDialog } from 'react-st-modal';

class Datacapture extends Component {

    state = {
        surveyCycleId: process.env.REACT_APP_CURRENT_SURVEY_CYCLE,
        setupComplete: false,
        organisationStateId: null,
        organisationStatus: null,
        capturedById: null,
        filledInById: null,
        captureType: null,
        dataCaptureId: null,
    }

    parseJwt(token) {
        const base64Payload = token.split('.')[1];
        const payload = atob(base64Payload);
        return JSON.parse(payload.toString());
    }

    async componentDidMount() {
        this.setState({ loading: true });

        SessionStateManager.clear();

        let bearer = localStorage.getItem('Bearer');
        if (!bearer){
            window.location = "/login";
        }

        let payload = this.parseJwt(bearer);

        this.setState({ capturedById: payload.user_id });

        await (async () => {
            await RolePermissionManagementService.initialiseRolesAndPermissions(payload.user_id);
        })([]);

        this.setState({ loading: false });
    }

    onSetupComplete = (evt, organisationStatus, captureType, dataCaptureId) => {
        this.setState({ organisationStateId: organisationStatus.organisationStateId });
        this.setState({ organisationStatus: organisationStatus });
        this.setState({ captureType: captureType });
        this.setState({ dataCaptureId: dataCaptureId });
        this.setState({ filledInById: organisationStatus.filledInBy });
        this.setState({ setupComplete: true });
    }

    async handleOnQuestionnaireComplete(evt) {

        const result = await CustomDialog(
            <QuestionnaireConfirmationDialog
                captureType={this.state.captureType}
                filledInById={this.state.filledInById}
                capturedById={this.state.capturedById}
                organisationStatus={this.state.organisationStatus}
            />, {
            className: styles.printviewDialog,
            title: 'Review & Confirm Questionnaire Submission',
            showCloseIcon: false,
            isFocusLock: true,
            isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away

        });

        if (result === true) {
            this.completeSurvey();
        } else {
            evt.preventDefault();
        }
    }

    completeSurvey() {
        const dataCapture = {
            "id": this.state.dataCaptureId,
            "completed": true,
            "capturedById": this.state.capturedById,
            "questionnaireTrackerId": this.state.organisationStatus.questionnaireTrackerId
        };

        DataCaptureService.completeCapture(dataCapture, this.state.captureType);

        this.setState({ setupComplete: false });
        this.setState({ organisationStateId: null });
        this.setState({ organisationStatus: null });
        this.setState({ captureType: null });
        this.setState({ filledInById: null });
        this.setState({ dataCaptureId: null });
    }

    render() {

        if (!this.state.setupComplete) {
            return <div className={styles.container_datacapture}>
                <div className={styles.container_row}>
                    <CaptureSetup surveyCycleId={this.state.surveyCycleId} capturedById={this.state.capturedById} onSetupComplete={this.onSetupComplete} />
                </div>
            </div>
        } else {
            return <div className={styles.container_datacapture}>
                <div className={styles.container_row}>
                    <Questionnaire
                        organisationStatus={this.state.organisationStatus}
                        organisationStateId={this.state.organisationStateId}
                        capturedById={this.state.capturedById}
                        filledInById={this.state.filledInById}
                        captureType={this.state.captureType}
                        printview={false}                                                // Set to false for navigation buttons
                        onQuestionnaireComplete={(evt) => this.handleOnQuestionnaireComplete(evt)}
                        dataCaptureId={this.state.dataCaptureId}
                    />
                </div>
            </div>
        }

    }
}
export default Datacapture;

function QuestionnaireConfirmationDialog(props) {
    const dialog = useDialog();

    let componentRef = null;
    return (
        <div>
            <div
                className={styles.confirmDialogOverlay}
                ref={(response) => (componentRef = response)}
            >
                <Questionnaire
                    organisationStatus={props.organisationStatus}
                    organisationStateId={props.organisationStatus.organisationStateId}
                    capturedById={props.capturedById}
                    filledInById={props.filledInById}
                    captureType={props.captureType}
                    printview={true}
                />
            </div>

            <div>
                <button
                    type="button"
                    className="btnBack"
                    onClick={(evt) => {
                        dialog.close(false);
                    }}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btnNext"
                    onClick={(evt) => {
                        dialog.close(true);
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    );
}